export default __webpack_public_path__ + "static/media/content.144afd38.gif";